

/** Swiper Option **/

const swiperOuter = document.getElementsByClassName('swiper-outer');
const swiperSlides = document.getElementsByClassName('swiper-slide');
const breakPoint = 768;
let mySwiper ;
let mySwiperBool ;

window.addEventListener('load',()=>{
	if( breakPoint < window.innerWidth){
		mySwiperBool = false;
	}else{
		createSwipter();
		mySwiperBool = true;
	}
},false);

window.addEventListener('resize',()=>{
	if( breakPoint < window.innerWidth && mySwiperBool){
		mySwiper.destroy(false,true);
		mySwiperBool = false;
	}else if( breakPoint >= window.innerWidth && !(mySwiperBool)){
		createSwipter();
		mySwiperBool = true;
	}
},false);

const createSwipter = () =>{
	mySwiper = new Swiper('.js-swiper1', {
		slidesPerView: 1.3,
		spaceBetween: 16,
		centeredSlides: true,
		initialSlide: 1,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		speed: 600,
		loop: true,
    	autoplay: {
        delay: 2400,
        disableOnInteraction: false,
      },
	});
}


/** Accordion **/

jQuery(function($){
	$('.l-accordion-head').on('click', function () {
		$(this).next(".l-accordion-body").slideToggle( 400,'swing' ).toggleClass('is-active');
		$(this).toggleClass('is-active');
	});
});


/** 開閉式追従ボタン **/
jQuery(function($){
  $('.article-sale-fixed-button__close-button').on('click', function () {
    if($(this).parent().hasClass('article-sale-fixed-button--opened')){
      $(this).parent().removeClass('article-sale-fixed-button--opened');
      $(this).parent().animate({'right':'-300px'},300).addClass('article-sale-fixed-button--closed');
    } else {
      $(this).parent().addClass('article-sale-fixed-button--opened');
      $(this).parent().addClass('article-sale-fixed-button--closed');
      $(this).parent().animate({'right':'0'},300);
    }
  });
});
